// test2827
(2827 && 0);
